export default __webpack_public_path__ + "static/media/page-back.0c65471a.svg";